import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

export default function AdminReferrals() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/referrals/admin').then(({data})=>setReferrals(data.referrals||[])).finally(()=>setLoading(false));
  }, []);

  const filtered = referrals.filter(r =>
    r.referrer?.username?.toLowerCase().includes(search.toLowerCase()) ||
    r.referred?.username?.toLowerCase().includes(search.toLowerCase())
  );

  const totalReferrers = [...new Set(referrals.map(r=>r.referrer?._id))].length;
  const totalCompleted = referrals.filter(r=>r.status==='completed').length;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h1 style={{fontFamily:'var(--font-display)',fontSize:24}}>REFERRALS</h1>
          <p style={{color:'var(--text-secondary)',fontSize:13,marginTop:4}}>Track who referred who and bonus distribution</p>
        </div>
        <div style={{display:'flex',gap:12}}>
          {[{label:'Total Referrals',val:referrals.length,color:'#f5c400'},{label:'Completed',val:totalCompleted,color:'#10b981'},{label:'Referrers',val:totalReferrers,color:'#7c3aed'}].map(s=>(
            <div key={s.label} style={{background:'var(--bg-card)',border:`1px solid ${s.color}44`,borderRadius:10,padding:'10px 18px',textAlign:'center'}}>
              <div style={{fontFamily:'var(--font-display)',fontSize:22,fontWeight:900,color:s.color}}>{s.val}</div>
              <div style={{fontSize:11,color:'var(--text-muted)'}}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <input placeholder="Search by username..." value={search} onChange={e=>setSearch(e.target.value)} style={{maxWidth:300,marginBottom:20}}/>

      {loading ? <div className="loading-spinner"><div className="spinner"/></div> : (
        <div className="card" style={{padding:0,overflow:'hidden'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead>
              <tr style={{borderBottom:'1px solid var(--border)',background:'var(--bg-secondary)'}}>
                {['Referrer','Referred User','Date','Bonus','Status'].map(h=>(
                  <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:11,color:'var(--text-secondary)',fontFamily:'var(--font-display)',letterSpacing:'0.06em'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(r=>(
                <tr key={r._id} style={{borderBottom:'1px solid var(--border)'}}
                  onMouseEnter={e=>e.currentTarget.style.background='var(--bg-card-hover)'}
                  onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{fontWeight:700,fontSize:14}}>{r.referrer?.username}</div>
                    <div style={{fontSize:11,color:'var(--text-muted)'}}>{r.referrer?.email}</div>
                  </td>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{fontWeight:700,fontSize:14}}>{r.referred?.username}</div>
                    <div style={{fontSize:11,color:'var(--text-muted)'}}>{r.referred?.email}</div>
                  </td>
                  <td style={{padding:'12px 16px',fontSize:13,color:'var(--text-secondary)'}}>{new Date(r.createdAt).toLocaleDateString()}</td>
                  <td style={{padding:'12px 16px'}}>
                    {r.bonusAwarded
                      ? <span style={{color:'#10b981',fontWeight:700,fontSize:13}}>+${r.bonusAmount} FC ✅</span>
                      : <span style={{color:'var(--text-muted)',fontSize:13}}>Pending</span>}
                  </td>
                  <td style={{padding:'12px 16px'}}>
                    <span style={{padding:'3px 10px',borderRadius:12,fontSize:12,fontWeight:700,background:r.status==='completed'?'rgba(16,185,129,0.12)':'rgba(245,196,0,0.12)',color:r.status==='completed'?'#10b981':'#f5c400',textTransform:'capitalize'}}>{r.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length===0&&<div style={{padding:'40px',textAlign:'center',color:'var(--text-secondary)'}}>No referrals found</div>}
        </div>
      )}
    </div>
  );
}
